<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <router-view/>
    <!-- <slideshow></slideshow>
    <nav-bar></nav-bar>
    <block block-title="Test">/</block> -->
  </div>
</template>

<script>


export default {

}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Roboto+Condensed|Sigmar+One|Roboto:wght@300');
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
  height: 100%;
  min-height: 100%;
}

body{
  min-height: 100%;
  height: 100%;
}

#app{
  height: inherit;
  min-height: inherit;
}


/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
} */

/* #nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
} */

/* #nav a.router-link-exact-active {
  color: #42b983;
} */
</style>
